/**
 * Add-user: business-error mapper.
 *
 * Reuses the shared `UserFormError` union (parameterised with the Add field map)
 * but pins the Add-flow default message ("Failed to create user."). The
 * `validation` variant is produced by the saga directly; this maps the infra
 * failures (`network` | `api`).
 */
import { classifyInfraError } from '@/utils/infra-error';

import type { UserFormError } from '../../_shared/domain/user-form-error';
import type { AddValidationErrors } from './add-user-draft.model';

export type AddUserError = UserFormError<AddValidationErrors>;

export function toAddUserError(e: unknown): AddUserError {
  return classifyInfraError(e, 'Failed to create user.');
}
